import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  TablePagination,
  Box,
  Card,
  Tooltip,
  List,
  CardActions,
  CardContent,
} from "@material-ui/core";
import CardHeader from "@material-ui/core/CardMedia";
import PageTitle from "../../../../components/PageTitle/PageTitle.js";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import useStyles from "../../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../css/employee-page.css";
import { useNotification } from "../../../../hooks/useNotification.js";
import MUIDataTable from "mui-datatables";

import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";

import CloseIcon from "@material-ui/icons/Close";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

export default function ApprovalPermissionList() {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();

  const [loader, setLoader] = useState(false);
  const [viewPermissionData, setViewPermissionData] = useState([]);
  const [viewPermissionDetails, setViewPermissionDetails] = useState([]);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  const validationSchema = Yup.object().shape({
    startTime: Yup.string().required("Start Time is required").nullable(),
    duration: Yup.string().required("Duration is required"),
    reason: Yup.string().required("Leave Reason is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      startTime: null,
      duration: "1hour",
      endTime: null,
      reason: "",
    },
  });

  // Watch for changes
  const startTime = watch("startTime");
  const duration = watch("duration");

  useEffect(() => {
    if (startTime && duration) {
      let endTime = moment(startTime);
      if (duration === "1hour") {
        endTime = endTime.add(1, "hour");
      } else if (duration === "2hour") {
        endTime = endTime.add(2, "hour");
      }
      setValue("endTime", endTime.toDate());
    }
  }, [startTime, duration, setValue]);

  useEffect(() => {
    fetchPermissionsData();
  }, []);

  const fetchPermissionsData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}permission/viewStatusWisePermissions`,
        data: {
          page: currerntPage,
          status: "APPROVED",
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setViewPermissionData(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    var data = JSON.stringify({
      page: newPage + 1,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}permission/viewAllPermissions`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setViewPermissionData(response.data.data);
        setCount(response.data.count);
      }
      setLoader(false);
    });
  };

  function ViewPermissionDetails(userId) {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}permission/viewStatusWisePermissions`,
        data: {
          page: currerntPage,
          status: "APPROVED",
          userId: userId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setViewPermissionDetails(response.data.data);

          toggleDrawer("right", true)();
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }


  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  function capitalizeFirstLetter(string) {
    return string?.charAt(0).toUpperCase()+string?.slice(1).toLowerCase();
  }

  const HeaderElements = () => <>Total : {count}</>;

  const list = (anchor) => (
    <>
      <Box sx={{ width: "100%", padding: "0 20px" }} role="presentation">
        <List>
          <Card className={classes.root} px={3}>
            <CardHeader>
              <Grid
                container
                direction="row"
                spacing={1}
                className={classes.drawerHeader}
              >
                <Typography variant="subtitle1"> Permission Details</Typography>

                <Grid className={classes.drawerClose}>
                  <CloseIcon
                    className={classes.closeBtn}
                    size="14px"
                    onClick={toggleDrawer(anchor, false)}
                  />
                </Grid>
              </Grid>
            </CardHeader>
            <CardContent className={classes.drawerViewContent}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Name:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {viewPermissionDetails[0]?.user.employee === null
                    ? viewPermissionDetails[0]?.user.recruiter.firstName +
                      " " +
                      viewPermissionDetails[0]?.user.recruiter.lastName
                    : viewPermissionDetails[0]?.user.employee.firstName +
                      " " +
                      viewPermissionDetails[0]?.user.employee.lastName}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Role Type:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {capitalizeFirstLetter(viewPermissionDetails[0]?.user?.roleName)}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                   Permission Time:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {moment.utc(viewPermissionDetails[0]?.fromTime).local().format("LT") + " - "+moment.utc(viewPermissionDetails[0]?.toTime).local().format("LT")}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    Duration:
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {(() => {
                    const fromTime = moment(viewPermissionDetails[0]?.fromTime);
                    const toTime = moment(viewPermissionDetails[0]?.toTime);
                    const duration = moment.duration(toTime.diff(fromTime));
                    const hours = Math.floor(duration.asHours());
                    return <Typography>{hours <= 1 ? hours+" Hour" : hours+" Hours"}</Typography>;
                  })()}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Permission Date:{" "}
                  </Typography>{" "}
                </Grid>
                
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {moment(viewPermissionDetails[0]?.fromTime).format(
                    "DD-MM-YYYY",
                  )}
                </Grid>

             
               

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Posted Date:{" "}
                  </Typography>{" "}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  {moment(viewPermissionDetails[0]?.createdAt).format(
                    "DD-MM-YYYY",
                  )}
                </Grid>


                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Status:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography style={{ color: "green" }}>
                    {viewPermissionDetails[0]?.status}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography className={classes.boldtext}>
                    {" "}
                    Approved Date:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <Typography>
                  {moment(viewPermissionDetails[0]?.updatedAt).format(
                    "DD-MM-YYYY",
                  )}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    {" "}
                    Reason:{" "}
                  </Typography>{" "}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    minHeight: "100px",
                  }}
                >
                  {" "}
                  {viewPermissionDetails[0]?.reason}
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </Card>
        </List>
      </Box>
    </>
  );

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Approved Permission List" />
        </Grid>
      </Grid>

      <Grid container spacing={2}></Grid>

      <Grid item xs={12}>
        <MUIDataTable
          title=""
          options={{
            textLabels: {
              body: {
                noMatch: "Oops! Matching record could not be found",
              },
            },
            pagination: false,
            sort: false,
            selectableRows: "none",
            search: false,
            filter: false,
            download: false,
            print: false,
            customToolbar: () => <HeaderElements />,
            responsive: mobileQuery === true ? "vertical" : "standard",
          }}
          columns={[
            {
              name: "S.No",
            },
            {
              name: "Employee Name",
            },
            {
              name: "Reason",
            },
            {
              name: "Duration",
            },
            {
              name: "Permission Time",
            },
            {
              name: "Permission Date",
            },
            {
              name: "Posted Date",
            },
            {
              name: "Approved Date",
            },
            {
              name: "Action",
            },
          ]}
          data={viewPermissionData.map((item, index) => {
            return [
              <>
                {currerntPage !== 0
                  ? 10 * currerntPage - 10 + index + 1
                  : index + 1}
              </>,
              getEmpName(item.user),
              <div
              key={index}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "200px",
                  whiteSpace: "nowrap",
                }}
              >
                {item.reason}
              </div>,
              (() => {
                const fromTime = moment(item.fromTime);
                const toTime = moment(item.toTime);
                const duration = moment.duration(toTime.diff(fromTime));
                const hours = Math.floor(duration.asHours());
                console.log(hours);
                return <Typography>{hours <= 1 ? hours+" Hour" : hours+" Hours"}</Typography>;
              })()
              ,
              moment(item.fromTime).format("LT") +" - "+ moment(item.toTime).format("LT"),
              moment(item.fromTime).format("DD-MM-YYYY"),
              moment(item.createdAt).format("DD-MM-YYYY"),
              moment(item.updatedAt).format("DD-MM-YYYY"),
              <>
                <Tooltip title="View JD" placement="bottom" aria-label="view">
                  <RemoveRedEyeIcon
                    className={classes.toolIcon}
                    onClick={() => ViewPermissionDetails(item.user.id)}
                  />
                </Tooltip>
              </>,
            ];
          })}
        />

        <Grid container spacing={2} className={classes.pagination}>
          <TablePagination
            rowsPerPageOptions={[50]}
            component="div"
            count={count}
            rowsPerPage={10}
            page={page}
            onPageChange={handleChangePage}
          />
        </Grid>
      </Grid>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {list("right")}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
